import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["modal"]
  static values = { hasIssues: Boolean }

  check(event) {
    if (this.hasIssuesValue) {
      event.preventDefault()
      event.stopImmediatePropagation()
      this.pendingUrl = event.currentTarget.getAttribute("href")
      this.pendingConfirm = event.currentTarget.getAttribute("data-confirm")
      $(this.modalTarget).modal("show")
    }
  }

  proceed() {
    $(this.modalTarget).modal("hide")
    if (this.pendingUrl) {
      // Replay data-confirm dialog if the original button had one (e.g. "Resetear y Procesar")
      if (this.pendingConfirm && !window.confirm(this.pendingConfirm)) {
        return
      }
      // Create a form and submit as POST (same as Rails UJS method: :post)
      var form = document.createElement("form")
      form.method = "post"
      form.action = this.pendingUrl
      // Add CSRF token
      var csrfToken = document.querySelector("meta[name='csrf-token']")
      if (csrfToken) {
        var input = document.createElement("input")
        input.type = "hidden"
        input.name = "authenticity_token"
        input.value = csrfToken.content
        form.appendChild(input)
      }
      document.body.appendChild(form)
      form.submit()
    }
  }
}
